import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Button } from "../../components/ui/button";
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle
} from "../../components/ui/card";
import SearchBar from "../ui/search-bar";
import {
    Mail,
} from "lucide-react";

const SubscribersManagement = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="space-y-6"
    >
        <div>
            <h2 className="text-3xl font-bold">Subscribers & Email</h2>
            <p className="text-muted-foreground">
                Manage subscribers and send newsletters
            </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
            <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2, duration: 0.3 }}
            >
                <Card>
                    <CardHeader>
                        <CardTitle>Subscriber Stats</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="space-y-4">
                            <div className="flex justify-between">
                                <span>Total Subscribers</span>
                                <span className="font-semibold">234</span>
                            </div>
                            <div className="flex justify-between">
                                <span>This Month</span>
                                <span className="font-semibold text-green-600">+23</span>
                            </div>
                            <div className="flex justify-between">
                                <span>Active Rate</span>
                                <span className="font-semibold">78%</span>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4, duration: 0.3 }}
            >
                <Card>
                    <CardHeader>
                        <CardTitle>Send Newsletter</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="space-y-4">
                            <Button className="w-full bg-purple-600 hover:bg-purple-700">
                                <Mail className="mr-2 h-4 w-4" />
                                Compose Newsletter
                            </Button>
                            <Button variant="outline" className="w-full">
                                View Email Templates
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </motion.div>
        </div>
    </motion.div>
);

export default SubscribersManagement;